import React from 'react';
import PropTypes from 'prop-types';

import ResultItem from './ResultItem';

const GuestResults = ({ groupNames, guests, guestSelect, onAddGuestGroup, token }) => {
  const [seated, unplaced] = Object.keys(guests).map(i => guests[i])
    .filter(guest => guest.displayName.toLowerCase().indexOf(token.toLowerCase()) !== -1)
    .reduce((acc, match) => (match.seatUUID !== null) 
        ? [acc[0].concat([match]), acc[1]]
        : [acc[0], acc[1].concat([match])]
      , [[], []])
  const noResults = seated.length === 0 && unplaced.length === 0;
  return (
    <div className="sc__search-results">
      {unplaced.map(guest => (
        <ResultItem
          guestSelect={() => guestSelect(guest.id, guest.displayName)}
          key={guest.id}
          name={guest.displayName}
          affiliation={groupNames[guest.affiliation]}
          token={token}
        />
      ))}
      {seated.length > 0 && <div className="sc__search-divider">Already seated</div>}
      {seated.length > 0
        && seated.map(guest => (
          <ResultItem
            guestSelect={() => guestSelect(guest.id, guest.displayName)}
            key={guest.id}
            name={guest.displayName}
            affiliation={groupNames[guest.affiliation]}
            token={token}
          />
        ))}
      {noResults && (
        <div className="sc__no-results">
          <p className="sc__no-results__title">Hm… we couldn’t find a match.</p>
          <p className="sc__no-results__sub-title">Make sure you’ve entered the correct name, or click below to add a new guest.</p>
          <a className="sc__no-results__add-link" onClick={onAddGuestGroup}>+ Add New Guest</a>
        </div>
      )}
    </div>
  );
};

GuestResults.propTypes = {
  guests: PropTypes.objectOf(PropTypes.shape({
    affiliation: PropTypes.string,
    displayName: PropTypes.string,
    groupID: PropTypes.number,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    seatUUID: PropTypes.string,
    tableUUID: PropTypes.string
  })),
  guestSelect: PropTypes.func,
  groupNames: PropTypes.shape({
    WEDDING_COUPLE: PropTypes.string,
    PRIMARY_FAMILY: PropTypes.string,
    PARTNER_FAMILY: PropTypes.string,
    PRIMARY_FRIEND: PropTypes.string,
    PARTNER_FRIEND: PropTypes.string,
    PRIMARY_WEDDING_PARTY: PropTypes.string,
    PARTNER_WEDDING_PARTY: PropTypes.string,
    PRIMARY_FAMILY_FRIEND: PropTypes.string,
    PARTNER_FAMILY_FRIEND: PropTypes.string,
    BOTH: PropTypes.string,
    UNKNOWN: PropTypes.string,
  }),
  onAddGuestGroup: PropTypes.func,
  token: PropTypes.string
};

export default GuestResults;



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/Tables/Seat/GuestResults.jsx